import React, { useEffect } from 'react';
import Expertise from './Expertise';
import { services } from '../data/services';
import { applyPageSeo, SITE_URL } from '../utils/seo';

const ServicesPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
    return applyPageSeo({
      title: 'IT Services in Satara | Website, App, WhatsApp API | Growmore',
      description:
        'IT services in Satara: website development company, mobile app development, software & ERP, WhatsApp Business API, AI automation, IVR, bulk SMS, SEO and cyber security.',
      keywords:
        'IT Services in Satara, Website Development Company in Satara, Mobile App Development Company in Satara, Software Development Company in Satara, AI Automation Company in Satara, WhatsApp Business Automation in Satara, Digital Marketing Company in Satara, Cyber Security Company in Satara, Growmore IT Services',
      path: '/services',
      image: '/services/service-website.png'
    });
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'IT Services in Satara by Growmore IT Services',
    itemListElement: services.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      url: `${SITE_URL}/services/${item.slug}`,
      name: item.title
    }))
  };

  return (
    <div className="pt-20 sm:pt-20 min-h-screen overflow-x-hidden bg-white dark:bg-dark-900">
      <h1 className="sr-only">Software &amp; IT Services in Satara — Web Development, Mobile Apps &amp; AI Automation | Growmore IT Services</h1>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <Expertise />
    </div>
  );
};

export default ServicesPage;
